import React, { useState,useRef } from "react";
import { Link } from "react-router-dom";
import { routePath as RP } from "../../app/components/router/routepath";
import "../../pages/styles.css";
import { useDispatch } from "react-redux";
import { addNewSponsor, fetchSponsorList } from "../../app/redux/slices/SponsorSlice"; 
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Swal from "sweetalert2";
import { uploadFormFilesReq } from "../../api/scholarshipapplication/scholarshipapplication";
import { useNavigate } from "react-router-dom";
export default function SponsorSignUpPage() {
    const [step, setStep] = useState(0);
    const [userType, setUserType] = useState("sponsor"); // default to sponsor
    const dispatch = useDispatch();
    const [basicDetails, setBasicDetails] = useState({
        sponsorName: "",
        orgType: "",
        email: "",
        phone: "",
        website: "",
         documents: [],
    });
    const [showPassword, setShowPassword] = useState(false);
    const [verification, setVerification] = useState({ username: "", password: "" });
    const [errors, setErrors] = useState({});

    // --- Validation regex ---
    const nameRegex = /^[A-Za-z\s]{1,150}$/;
  //  const emailRegex =  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.(com|org|net|edu|co\.in)$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


    const phoneRegex = /^[0-9]{10}$/;
    const usernameRegex = /^[A-Za-z0-9_]{3,20}$/;
    const passwordRegex =
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/;
    const websiteOrLinkedInRegex =
       /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$|^https?:\/\/(www\.)?linkedin\.com\/(in|company)\/[A-Za-z0-9_-]+\/?$/;
const fileInputRef = useRef(null);
 const [selectedFiles, setSelectedFiles] = useState([]); // newly selected files
const [filesList, setFilesList] = useState( []); // display names
const [fileSelected, setFileSelected] = useState(false);
const [newFileSelected, setNewFileSelected] = useState(false);
 const [existingDocFiles, setExistingDocFiles] = useState([]);
const [originalFiles, setOriginalFiles] = useState([]);
const isValidEmail = (email) => {
    email = email.trim();

    // Basic regex: no spaces, contains @, proper chars
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) return false;

    const [local, domain] = email.split("@");
    if (!local || !domain) return false;

    // Local part rules
    if (local.startsWith(".") || local.endsWith(".")) return false;
    if (local.includes("..")) return false;

    // Domain rules
    if (domain.startsWith(".") || domain.endsWith(".")) return false;
    if (domain.includes("..")) return false;

    const domainParts = domain.split(".");
    if (domainParts.length < 2) return false;

    // Last two domain parts cannot be same (reject domain.com.com)
    const lastIndex = domainParts.length - 1;
    if (domainParts[lastIndex] === domainParts[lastIndex - 1]) return false;

    // Each domain part must contain only letters, numbers, hyphen (no special chars)
    for (let part of domainParts) {
      if (!/^[a-zA-Z0-9-]+$/.test(part)) return false;
      if (part.startsWith("-") || part.endsWith("-")) return false; // no hyphen at start/end
    }

    return true;
  };

  const navigate = useNavigate();
const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  if (!files || files.length === 0) return;

  setSelectedFiles(files);               // store File objects
  setFilesList(files.map(f => f.name));  // store names for display

  setBasicDetails({ ...basicDetails, documents: files }); // attach to basicDetails
  setFileSelected(true);
};
  // Upload files function returns uploaded file names
  const uploadFiles = async (applicationId) => {
    if (selectedFiles.length < 1) return [];

    const formDataPayload = new FormData();
    selectedFiles.forEach((file) => formDataPayload.append("FormFiles", file));
    formDataPayload.append("TypeofUser", "sponsor");
    formDataPayload.append("id", applicationId);

    try {
      await uploadFormFilesReq(formDataPayload);

      // Return names of uploaded files for merging
      return selectedFiles.map(f => f.name);
    } catch (ex) {
      console.error("File upload failed:", ex);
      return [];
    }
  };
  const handleRemoveSingleFile = (index) => { 
    
  const updatedFiles = existingDocFiles.filter((_, i) => i !== index);
  //setExistingDocFiles(updatedFiles);
   setFilesList(updatedFiles);

  /*setFormData(prev => ({
    ...prev,
    files: updatedFiles,
    fileName: updatedFiles.length > 0 ? updatedFiles.join("|") : "",
  }));*/
   // flags
  if (updatedFiles.length === 0) {
    setFileSelected(false);
    setNewFileSelected(false);
  }

  // clear input
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
  
};
const handleClear = () => {
  setSelectedFiles([]);
  setFilesList([]);
  setFileSelected(false);
  setBasicDetails({ ...basicDetails, documents: [] }); // clear documents
  if (fileInputRef.current) fileInputRef.current.value = null;
};


    // --- Step validation ---
    const validateStep = () => {
        let stepErrors = {};

       if (step === 0) {
    // Sponsor Name
   if (!basicDetails.email) {
        stepErrors.email = "Email is required.";
      } else if (!isValidEmail(basicDetails.email)) {
        stepErrors.email = "Enter a valid email.";
      }

    // Organization Type
    if (!basicDetails.orgType) 
        stepErrors.orgType = "Organization type required.";

    // Email
  

    // Phone
    if (!basicDetails.phone)
        stepErrors.phone = "Phone number is required.";
    else if (!phoneRegex.test(basicDetails.phone))
        stepErrors.phone = "Phone number must be 10 digits.";

    // Website
    if (!basicDetails.website)
        stepErrors.website = "Website / LinkedIn is required.";
    else if (!websiteOrLinkedInRegex.test(basicDetails.website))
        stepErrors.website = "Enter a valid Website or LinkedIn URL (https://...).";
}

       if (step === 1) {
    // Email
    // Email
const username = verification.username.trim();
      if (!username) {
        stepErrors.username = "Email is required.";
      } else if (!isValidEmail(username)) {
        stepErrors.username = "Enter a valid email.";
      }



    // Password
    if (!verification.password) {
        stepErrors.password = "Password is required.";
    } else if (!passwordRegex.test(verification.password)) {
        stepErrors.password =
            "Password min 6 chars, must include letters, numbers & 1 special char.";
    }
}


        setErrors(stepErrors);
        return Object.keys(stepErrors).length === 0;
    };

    const nextStep = () => {
        if (validateStep()) setStep(step + 1);
    };
    const prevStep = () => setStep(step - 1);

    const handleSave = async () => {
    if (!validateStep()) return;

    const data = {
        OrganizationName: basicDetails.sponsorName,
        OrganizationType: basicDetails.orgType,
        Email: basicDetails.email,
        Phone: basicDetails.phone,
        Website: basicDetails.website,
        Username: verification.username,
        PasswordHash: verification.password, // or hash it if backend expects hash
        RoleId: userType === "student" ? 1 : userType === "sponsor" ? 2 : 3,
        CreatedBy: localStorage.getItem("name") // or dynamic user
    };

    try {
     const res =    await addNewSponsor(data, dispatch);
     const userId =res.id;
      if (!userId) return; // stop if insertion failed
//alert("Sponsor registered successfully!");
// 2️⃣ Upload documents if any
  if (basicDetails.documents && basicDetails.documents.length > 0) {
    try {
      await uploadFiles(userId);
    } catch (err) {
      console.error("File upload failed:", err);
      Swal.fire({
        text: "Documents upload failed!",
        icon: "error",
      });
      return;
    }
  }

 
        setBasicDetails({ sponsorName: "", orgType: "", email: "", phone: "", website: "" });
        setVerification({ username: "", password: "" });
        setStep(0);
         // 3️⃣ Show success alert after everything
  await Swal.fire({
    text: "Signup successful!",
    icon: "success",
    confirmButtonText: "OK",
  });

  // 4️⃣ Navigate to login
  navigate("/login");
    } catch (error) {
        console.error("Error saving sponsor:", error);
    }
};


    // --- Step completed check ---
    const isStepCompleted = (stepIndex) => {
        if (stepIndex === 0) {
            return (
                basicDetails.sponsorName &&
                nameRegex.test(basicDetails.sponsorName) &&
                basicDetails.orgType &&
                basicDetails.email &&
        isValidEmail(basicDetails.email) &&
                basicDetails.phone &&
                phoneRegex.test(basicDetails.phone) &&
                basicDetails.website
            );
        }
        return true;
    };

    return (
        <div className="sponsorsignup-container">
            <div className="sponsorsignup-card">
                {/* Header */}
                <div className="sponsorsignup-header">
                    <h2>Sponsor Sign up</h2>
                    <p>
                        Already a sponsor?{" "}
                                  <Link
                          to={RP.login}
                          state={{ userType }}
                          className="sponsorsignup-link"
                        >
                          Sign in
                        </Link>
                    </p>
                </div>

                {/* Step navigation */}
                <div className="sponsorsignup-steps">
                    {["Organization Details", "Verification"].map((label, i) => (
                        <div key={i} className="step-item">
                            <div
                                className={`step-circle ${i === step ? "active" : ""} ${i > 0 && !isStepCompleted(i - 1) ? "disabled" : ""
                                    }`}
                                onClick={() => {
                                    if (i === 0 || isStepCompleted(i - 1)) setStep(i);
                                }}
                                title={label}
                            >
                                {i + 1}
                            </div>
                            <span className="step-label">{label}</span>
                        </div>
                    ))}
                </div>

                {/* Step content */}
                {/* Step content */}
               {step === 0 && (
  <div>
    <h3 className="sponsor-section-title">Organization Details</h3>

    <div className="row">
      <div className="form-group">
        <label>Organization/Sponsor Name *</label>
        <input
          type="text"
          value={basicDetails.sponsorName}
          onChange={(e) => {
  const value = e.target.value;

  if (/^[A-Za-z\s]*$/.test(value)) {
    setBasicDetails({ ...basicDetails, sponsorName: value });
  }
}}

          className={errors.sponsorName ? "input-error" : ""}
          placeholder="Organization / Sponsor Name"
        />
        {errors.sponsorName && <p className="error-text">{errors.sponsorName}</p>}
      </div>

      <div className="form-group">
        <label>Organization/Sponsor Type *</label>
        <select
          value={basicDetails.orgType}
          onChange={(e) =>
            setBasicDetails({ ...basicDetails, orgType: e.target.value })
          }
          className={errors.orgType ? "input-error" : ""}
        >
          <option value="">--Select--</option>
          <option value="Company">Company</option>
          <option value="NGO">NGO</option>
          <option value="Government">Government</option>
          <option value="Individual">Individual</option>
        </select>
        {errors.orgType && <p className="error-text">{errors.orgType}</p>}
      </div>
    </div>

    <div className="row">
      <div className="form-group">
        <label>Email *</label>
        <input
  type="email"
  value={basicDetails.email}
  onChange={(e) =>
    setBasicDetails({ ...basicDetails, email: e.target.value })
  }
  className={errors.email ? "input-error" : ""}
  placeholder="Email"
/>

        {errors.email && <p className="error-text">{errors.email}</p>}
      </div>

      <div className="form-group">
        <label>Phone *</label>
        <input
         type="text"
         maxLength={10}
         value={basicDetails.phone}
         onChange={(e) => {
         const value = e.target.value;
         if (/^\d*$/.test(value)) {
        setBasicDetails({ ...basicDetails, phone: value });
        }
      }}
       className={errors.phone ? "input-error" : ""}
      placeholder="Phone Number"
      />

        {errors.phone && <p className="error-text">{errors.phone}</p>}
      </div>
    </div>

    <div className="row">
      <div className="form-group">
        <label>Website / LinkedIn *</label>
        <input
          type="text"
          value={basicDetails.website}
          onChange={(e) =>
            setBasicDetails({ ...basicDetails, website: e.target.value })
          }
          className={errors.website ? "input-error" : ""}
          placeholder="https://yourwebsite.com"
        />
        {errors.website && <p className="error-text">{errors.website}</p>}
      </div>
      
    </div>
       <div className="form-group col-12">
                <label>Upload Profile Photo</label>
                <input
                  type="file"
                   accept="image/*"  
                  name="documents"
                  onChange={handleFileChange}
                  //multiple
                  ref={fileInputRef}
                 // disabled={isViewMode}
                />

                {fileSelected && filesList.length > 0 && (
                  <button
                    type="button"
                    className="btn btn-sm btn-danger mt-2"
                    onClick={handleClear}
                     style={{ marginTop: "10px" }}
                  >
                    Clear
                  </button>
                )}

               {filesList.length > 0 && (
    <div className="d-flex flex-column mt-2 rounded"style={{ marginTop: "5px" }}>
      {filesList.map((fileName, index) => (
        <div
          key={index}
          className="d-flex align-items-center justify-content-between border rounded p-2 mb-1"
           style={{
          gap: "12px",
          paddingLeft: "14px",
          paddingRight: "12px",
          color:"black"
        }}
        >
          <span>{fileName}</span>
          <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveSingleFile(index)}
              style={{ marginLeft: "5px" }}
            >
              ×
            </button>
        </div>
      ))}
    </div>
  )}
  </div>
  </div>
)}

{step === 1 && (
  <div>
    <h3 className="sponsor-section-title">Verification</h3>

    <div className="row">
      <div className="form-group">
        <label>User Name(Email) *</label>
       <input
  type="email"
  placeholder="Enter your email"
  value={verification.username}
  onChange={(e) =>
    setVerification({ ...verification, username: e.target.value })
  }
  className={errors.username ? "input-error" : ""}
/>



        {errors.username && <p className="error-text">{errors.username}</p>}
      </div>

      <div className="form-group">
  <label>Password *</label>

  <div className="password-wrapper">
    <input
      type={showPassword ? "text" : "password"}
      placeholder="Password"
      value={verification.password}
      onChange={(e) =>
        setVerification({ ...verification, password: e.target.value })
      }
      className={errors.password ? "input-error" : ""}
    />

    <span
      className="password-toggle"
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
    </span>
  </div>

  {errors.password && <p className="error-text">{errors.password}</p>}
</div>

    </div>
  </div>
)}


               
                {/* Navigation buttons */}
                <div className="nav-buttons">
                    {step > 0 && (
                        <button onClick={prevStep} className="nav-btn">
                            Previous
                        </button>
                    )}
                    {step < 1 && (
                        <button onClick={nextStep} className="nav-btn">
                            Next
                        </button>
                    )}
                    {step === 1 && (
                        <button onClick={handleSave} className="save-btn">
                            Save
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
